/**
 * ============================================================================
 * MIGRATED FILE — DO NOT EDIT
 * ============================================================================
 *
 * This file has been migrated to academy-content-ui.
 * Canonical source: academy-content-ui/static/js/features/academyAi/academyAiQueries.ts
 *
 * This .migrated copy is retained only for LearningCenterUI consumers that
 * have not yet moved to academy-content-ui. All changes should be made in
 * academy-content-ui first, then synced here if still needed.
 *
 * This copy will be deleted when LearningCenterUI is shut down.
 *
 * @migrated-to academy-content-ui
 * ============================================================================
 */
import { useGetSimilarItemsQuery } from '../../../__generated__/chirp/com/hubspot/academy/ai/rpc/CatalogItemRecommendationRpc.hooks';
import getLang from 'academy-common-lib/utils/getLang';
import { MY_SAVED_ITEMS_PAGE_SIZE } from '../savedItems/savedItemsTypes.migrated';
const toChirpItemType = type => {
  switch (type) {
    case 'SHORT_FORM_CONTENT':
      return 'SHORT_VIDEO';
    case 'TRACK':
      return 'COURSE';
    case 'LESSON':
      return 'LESSON';
    default:
      throw new Error(`Unsupported LearningContentType for CHIRP: ${type}`);
  }
};
const fromChirpItemType = type => {
  switch (type) {
    case 'SHORT_VIDEO':
      return 'SHORT_FORM_CONTENT';
    case 'COURSE':
      return 'TRACK';
    default:
      return type;
  }
};

/**
 * @migrated-to academy-content-ui
 * @deprecated
 * This file has been migrated to academy-content-ui.
 * Canonical source: academy-content-ui/static/js/features/academyAi/academyAiQueries.ts
 *
 * This .migrated copy is retained only for LearningCenterUI consumers that
 * have not yet moved to academy-content-ui. All changes should be made in
 * academy-content-ui first, then synced here if still needed.
 *
 * This copy will be deleted when LearningCenterUI is shut down.
 */
export const useAiRecommendationsForLearningContent = ({
  item: {
    id,
    type,
    language
  },
  size = MY_SAVED_ITEMS_PAGE_SIZE,
  resultTypes = ['TRACK', 'LESSON', 'SHORT_FORM_CONTENT'],
  skip
}) => {
  const lang = (language || getLang()).toUpperCase();
  const {
    data: recommendationsResponse,
    loading: recommendationsLoading,
    error: recommendationsError
  } = useGetSimilarItemsQuery({
    variables: {
      itemKey: {
        itemId: id,
        type: toChirpItemType(type)
      },
      itemTypes: resultTypes.map(toChirpItemType),
      languages: [lang],
      limit: size
    },
    skip
  });
  const results = recommendationsResponse === null || recommendationsResponse === void 0 ? void 0 : recommendationsResponse.results;
  return {
    recommendations: results === null || results === void 0 ? void 0 : results.map(r => {
      var _r$language;
      return {
        recommendationId: r.itemKey.itemId,
        recommendationType: fromChirpItemType(r.itemKey.type),
        language: (_r$language = r.language) === null || _r$language === void 0 ? void 0 : _r$language.toLowerCase()
      };
    }),
    recommendationsLoading,
    recommendationsError
  };
};